import { DrawerId, FormId } from "components/CC/types/models.ts";
import { BaseConnectionCreatorDrawer } from "components/CC/UI/BaseConnectionCreatorDrawer.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation.tsx";

import { HttpMethodForm } from "../Forms/HttpMethodForm.tsx";

export const HttpMethodDrawer = () => {
    const { t } = usePaldockTranslation("components.connection-creator");

    return (
        <BaseConnectionCreatorDrawer drawerId={DrawerId.HttpMethod} title={t("nodes.http_method.drawers.title")}>
            <HttpMethodForm formId={FormId.HttpMethodForm} />
        </BaseConnectionCreatorDrawer>
    );
};
